var _defs, _use, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThermometerColder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "c",
    viewBox: "0 0 72 168"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 132,
    r: 36,
    fill: "#2885c7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2885c7",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 24,
    d: "M36 12v120"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    calcMode: "spline",
    dur: "1s",
    keySplines: ".42, 0, .58, 1; .42, 0, .58, 1",
    repeatCount: "indefinite",
    type: "translate",
    values: "0 0; 0 18; 0 0"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "d",
    viewBox: "0 0 118 278"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    stroke: "url(#b)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: "M115 218.2c0 31.4-25 56.8-56 56.8S3 249.6 3 218.2a57 57 0 0124-46.6V35.5a32 32 0 1164 0v136a57 57 0 0124 46.7ZM63 83h28M63 51h28m-28 64h28"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "e",
    viewBox: "0 0 118 278"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    width: 72,
    height: 168,
    transform: "translate(23 87)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    width: 118,
    height: 278
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -7.2,
    x2: 116.4,
    y1: 36.3,
    y2: 250.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#515a69",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#6b7280",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#384354",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -8.7,
    x2: 117.9,
    y1: 33.7,
    y2: 253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d4d7dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#d4d7dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bec1c6"
  })))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    width: 118,
    height: 278,
    transform: "translate(197 117)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2a81bf",
    d: "M372.5 271a4.6 4.6 0 00-3.2 1.3L350 290.7l-19.3-18.4a4.6 4.6 0 00-6.4 0 4.1 4.1 0 000 6l22.5 21.4a4.6 4.6 0 006.4 0l22.5-21.4a4.1 4.1 0 000-6 4.6 4.6 0 00-3.2-1.3Z",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: "-1.2s",
    calcMode: "spline",
    dur: "3s",
    keySplines: ".55, 0, .1, 1; .55, 0, .1, 1",
    repeatCount: "indefinite",
    type: "translate",
    values: "0 -30; 0 0; 0 30"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "-1.2s",
    calcMode: "spline",
    dur: "3s",
    keySplines: ".55, 0, .1, 1; .55, 0, .1, 1",
    repeatCount: "indefinite",
    values: "0; 1; 0"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a81bf",
    d: "M372.5 244a4.6 4.6 0 00-3.2 1.3L350 263.7l-19.3-18.4a4.6 4.6 0 00-6.4 0 4.1 4.1 0 000 6l22.5 21.4a4.6 4.6 0 006.4 0l22.5-21.4a4.1 4.1 0 000-6 4.6 4.6 0 00-3.2-1.3Z",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: "-1.1s",
    calcMode: "spline",
    dur: "3s",
    keySplines: ".55, 0, .1, 1; .55, 0, .1, 1",
    repeatCount: "indefinite",
    type: "translate",
    values: "0 -30; 0 0; 0 30"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "-1.1s",
    calcMode: "spline",
    dur: "3s",
    keySplines: ".55, 0, .1, 1; .55, 0, .1, 1",
    repeatCount: "indefinite",
    values: "0; 1; 0"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a81bf",
    d: "M372.5 217a4.6 4.6 0 00-3.2 1.3L350 236.7l-19.3-18.4a4.6 4.6 0 00-6.4 0 4.1 4.1 0 000 6l22.5 21.4a4.6 4.6 0 006.4 0l22.5-21.4a4.1 4.1 0 000-6 4.6 4.6 0 00-3.2-1.3Z",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: "-1s",
    calcMode: "spline",
    dur: "3s",
    keySplines: ".55, 0, .1, 1; .55, 0, .1, 1",
    repeatCount: "indefinite",
    type: "translate",
    values: "0 -30; 0 0; 0 30"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "-1s",
    calcMode: "spline",
    dur: "3s",
    keySplines: ".55, 0, .1, 1; .55, 0, .1, 1",
    repeatCount: "indefinite",
    values: "0; 1; 0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThermometerColder);
export default __webpack_public_path__ + "static/media/thermometer-colder.b930564a3e431185e50ffcfe28e23368.svg";
export { ForwardRef as ReactComponent };